<template>
  <div ref="modaldes" class="modal" tabindex="-1" role="dialog" id="modal-ndescuento">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header py-2" style="background:#1565C0; color:#fff;">
          <h5 class="modal-title mb-0 d-flex align-items-center">
            <v-icon left color="white" small>mdi-sale</v-icon>
            <b>Solicitar Descuento</b>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Cerrar" style="color:#fff; text-shadow:none; opacity:.9;">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body p-3" v-if="ins && ins.estudiante">
          <!-- Info estudiante -->
          <v-card outlined class="mb-3" style="background:#F5F8FB;">
            <v-card-text class="py-2 px-3">
              <v-row dense no-gutters>
                <v-col cols="12" sm="6" class="d-flex align-center">
                  <v-icon small color="blue darken-3" class="mr-2">mdi-account</v-icon>
                  <div>
                    <div class="caption grey--text text--darken-1" style="font-size:10px;">ESTUDIANTE</div>
                    <div class="font-weight-medium" style="font-size:13px;">
                      {{ ins.estudiante.nombres }} {{ ins.estudiante.pri_apellido }} {{ ins.estudiante.seg_apellido }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" class="d-flex align-center">
                  <v-icon small color="teal darken-2" class="mr-2">mdi-account-tie</v-icon>
                  <div>
                    <div class="caption grey--text text--darken-1" style="font-size:10px;">ASESOR</div>
                    <div class="font-weight-medium" style="font-size:13px;">
                      {{ ins.asesor.nombres }} {{ ins.asesor.pri_apellido }} {{ ins.asesor.seg_apellido }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Tabs -->
          <v-tabs v-model="tab" dense height="36" color="blue darken-2" slider-color="blue darken-2" class="mb-2">
            <v-tab style="font-size:12px;">
              <v-icon x-small left>mdi-tag-outline</v-icon>
              Descuento único
            </v-tab>
            <v-tab style="font-size:12px;">
              <v-icon x-small left>mdi-tag-multiple-outline</v-icon>
              Descuento por varios conceptos
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <!-- ─────────────── TAB 1: Comportamiento original ─────────────── -->
            <v-tab-item>
              <div class="pt-3">
                <p class="mb-0"><span class="text-danger">*</span> Concepto para descontar</p>
                <div>
                  <select class="form-control" v-model.number="concepto">
                    <option value=""></option>
                    <option v-for="(c, ind) in conceptos" :key="ind" :value="c"> ({{ c.id }}) {{ c.nombre }} </option>
                  </select>
                  <small v-if="concepto" class="blue--text ml-1">
                    <b>Monto:</b> {{ concepto.monto }} bs, <b>Saldo:</b> {{ concepto.saldo }} bs
                  </small>
                </div>

                <p class="mb-0 mt-4"><span class="text-danger">*</span> Motivo del descuento</p>
                <div>
                  <select class="form-control" v-model="motivo">
                    <option v-for="(m, ind) in motivos" :key="ind" :value="m"> {{ m.descripcion }} </option>
                  </select>
                </div>

                <p class="mb-0 mt-4"><span class="text-danger">*</span> Ingrese el monto del descuento</p>
                <v-radio-group v-model="porcentual" row dense hide-details class="mt-0 xcard pa-0">
                  <v-radio label="Entero" :value="false"></v-radio>
                  <v-radio label="Porcentual" :value="true"></v-radio>
                  <v-col cols="4" class="pt-0">
                    <v-text-field
                      hide-details=""
                      v-model.number="monto"
                      :rules="validarCampo()"
                      type="number"
                      :label="porcentual ? 'Porcentaje descuento' : 'Monto descuento'"
                      :prefix="porcentual ? '' : 'Bs:'"
                      :suffix="porcentual ? '%' : ''"
                      placeholder="....."
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pt-0" v-if="porcentual">
                    <v-text-field
                      hide-details=""
                      v-model.number="monto_porcentual"
                      prefix="$"
                      :disabled="true"
                      type="number"
                      label="Monto"
                      placeholder="..."
                    ></v-text-field>
                  </v-col>
                </v-radio-group>

                <label for="H" class="mb-0 mt-4"> <input type="checkbox" v-model="prorratear" /> Prorratear </label>
                <span> (Seleccione si desea prorratear) </span>

                <p class="mb-0 mt-4"><span class="text-danger">*</span> Descripcion del descuento</p>
                <div>
                  <textarea
                    class="form-control"
                    v-model.trim="descripcion"
                    rows="4"
                    placeholder="Ingrese una descripcion de la solicitud de descuento..."
                  >
                  </textarea>
                </div>
              </div>
            </v-tab-item>

            <!-- ─────────────── TAB 2: Múltiples conceptos ─────────────── -->
            <v-tab-item>
              <div class="pt-3">
                <v-row dense>
                  <v-col cols="12" md="7">
                    <p class="mb-1" style="font-size:12px; font-weight:600;">
                      <span class="text-danger">*</span> Motivo del descuento
                    </p>
                    <v-select
                      v-model="motivoMulti"
                      :items="motivos"
                      item-text="descripcion"
                      return-object
                      outlined dense hide-details
                      placeholder="Seleccionar motivo..."
                    />
                  </v-col>
                  <v-col cols="12" md="5">
                    <p class="mb-1" style="font-size:12px; font-weight:600;">
                      <span class="text-danger">*</span> Tipo de monto
                    </p>
                    <v-btn-toggle v-model="porcentualMulti" mandatory dense class="w-100">
                      <v-btn :value="false" small class="flex-grow-1" :color="porcentualMulti === false ? 'blue darken-2' : ''" :dark="porcentualMulti === false">
                        <v-icon x-small left>mdi-cash</v-icon>Entero (Bs)
                      </v-btn>
                      <v-btn :value="true" small class="flex-grow-1" :color="porcentualMulti === true ? 'blue darken-2' : ''" :dark="porcentualMulti === true">
                        <v-icon x-small left>mdi-percent-outline</v-icon>Porcentual
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>

                <!-- Conceptos (multi-selección) -->
                <div class="mt-3">
                  <div class="d-flex align-center mb-1">
                    <span style="font-size:12px; font-weight:600;">
                      <span class="text-danger">*</span> Conceptos a descontar
                    </span>
                    <v-chip v-if="seleccionados.length > 0" x-small color="blue darken-2" dark class="ml-2">
                      {{ seleccionados.length }} seleccionado(s)
                    </v-chip>
                    <v-spacer />
                    <v-btn x-small text color="blue darken-2" @click="seleccionarTodos" v-if="conceptos.length > 0">
                      <v-icon x-small left>mdi-check-all</v-icon>
                      {{ todosSeleccionados ? 'Quitar todos' : 'Seleccionar todos' }}
                    </v-btn>
                  </div>

                  <div v-if="conceptos.length === 0" class="text-center py-3 grey--text caption">
                    {{ loading ? 'Cargando conceptos...' : 'No hay conceptos que acepten descuentos' }}
                  </div>

                  <v-simple-table v-else dense class="conceptos-table">
                    <thead>
                      <tr style="background:#ECEFF1;">
                        <th style="width:34px;"></th>
                        <th style="font-size:11px;">Concepto</th>
                        <th class="text-right" style="font-size:11px; width:90px;">Monto</th>
                        <th class="text-right" style="font-size:11px; width:90px;">Saldo</th>
                        <th class="text-right" style="font-size:11px; width:140px;">
                          {{ porcentualMulti ? '% Descuento' : 'Descuento (Bs)' }}
                        </th>
                        <th class="text-right" v-if="porcentualMulti" style="font-size:11px; width:100px;">Equiv. Bs</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(c) in conceptos" :key="c.id" :class="{ 'row-selected': isSelected(c) }">
                        <td class="pr-0">
                          <v-checkbox
                            :input-value="isSelected(c)"
                            @change="toggleConcepto(c)"
                            dense hide-details class="ma-0 pa-0"
                          />
                        </td>
                        <td style="font-size:12px;">
                          <span class="grey--text caption">({{ c.id }})</span> {{ c.nombre }}
                        </td>
                        <td class="text-right" style="font-size:12px;">{{ formatBs(c.monto) }}</td>
                        <td class="text-right" style="font-size:12px;">
                          <span :class="c.saldo > 0 ? 'orange--text text--darken-2' : 'grey--text'">
                            {{ formatBs(c.saldo) }}
                          </span>
                        </td>
                        <td class="text-right">
                          <v-text-field
                            v-if="isSelected(c)"
                            :value="getMonto(c)"
                            @input="setMonto(c, $event)"
                            type="number" min="0" dense hide-details outlined
                            :suffix="porcentualMulti ? '%' : ''"
                            :prefix="porcentualMulti ? '' : 'Bs'"
                            style="font-size:12px;"
                            class="descuento-input"
                          />
                          <span v-else class="grey--text caption">—</span>
                        </td>
                        <td v-if="porcentualMulti" class="text-right" style="font-size:12px;">
                          <span v-if="isSelected(c)" class="blue--text text--darken-2 font-weight-bold">
                            {{ formatBs(equivalenteBs(c)) }}
                          </span>
                          <span v-else class="grey--text">—</span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot v-if="seleccionados.length > 0">
                      <tr style="background:#E8F5E9; border-top:2px solid #81C784;">
                        <td colspan="4" class="text-right font-weight-bold" style="font-size:12px;">TOTAL DESCUENTO:</td>
                        <td class="text-right font-weight-bold green--text text--darken-2" style="font-size:13px;">
                          <template v-if="porcentualMulti">—</template>
                          <template v-else>{{ formatBs(totalDescuento) }}</template>
                        </td>
                        <td v-if="porcentualMulti" class="text-right font-weight-bold green--text text--darken-2" style="font-size:13px;">
                          {{ formatBs(totalDescuento) }}
                        </td>
                      </tr>
                    </tfoot>
                  </v-simple-table>
                </div>

                <!-- Prorratear + Descripción -->
                <v-row dense class="mt-3">
                  <v-col cols="12" md="5" class="d-flex align-center">
                    <v-checkbox
                      v-model="prorratearMulti"
                      label="Prorratear descuento"
                      hint="(No disponible en descuento múltiple)"
                      dense hide-details persistent-hint
                      
                      class="ma-0 pa-0"
                    />
                  </v-col>
                  <v-col cols="12" md="7">
                    <p class="mb-1" style="font-size:12px; font-weight:600;">
                      <span class="text-danger">*</span> Descripción
                    </p>
                    <v-textarea
                      v-model.trim="descripcionMulti"
                      outlined dense hide-details
                      rows="2" auto-grow
                      placeholder="Ingrese una descripción de la solicitud de descuento..."
                      style="font-size:12px;"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-tab-item>
          </v-tabs-items>

          <!-- Mensaje + progreso (común) -->
          <v-alert v-if="msg" :type="exitoso ? 'success' : 'error'" dense text class="mt-3 mb-0 caption">
            {{ msg }}
          </v-alert>
          <v-progress-linear v-if="loading" indeterminate color="blue darken-2" height="2" class="mt-2" />
        </div>

        <div class="modal-footer py-2">
          <div v-if="tab === 1 && seleccionados.length > 0" class="flex-grow-1 d-flex align-center">
            <v-chip small color="green darken-1" dark>
              <v-icon x-small left>mdi-cash-multiple</v-icon>
              Total: Bs {{ formatBs(totalDescuento) }}
            </v-chip>
          </div>
          <button
            @click="validar()"
            :disabled="loading || exitoso || (tab === 1 && seleccionados.length === 0)"
            type="button"
            class="btn btn-azul white--text">
            Solicitar{{ tab === 1 && seleccionados.length > 1 ? ` (${seleccionados.length})` : '' }}
          </button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    props: { ins: { type: Object, required: true } },
    data() {
      return {
        tab: 0,
        motivos: [],
        descuentostipos: [],
        conceptos: [],
        xins: {},
        xprograma: {},
        msg: '',
        loading: false,

        // Tab 1 (comportamiento original - descuento único)
        motivo: {},
        concepto: null,
        prorratear: false,
        monto: null,
        monto_porcentual: null,
        inscripcion_id: null,
        descripcion: '',
        porcentual: false,
        exitoso: false,

        // Tab 2 (múltiples conceptos)
        motivoMulti: {},
        porcentualMulti: false,
        prorratearMulti: false,
        descripcionMulti: '',
        seleccion: {}, // { [conceptoId]: monto }
      };
    },
    computed: {
      seleccionados() {
        return this.conceptos.filter(c => this.seleccion[c.id] !== undefined);
      },
      todosSeleccionados() {
        return this.conceptos.length > 0 && this.seleccionados.length === this.conceptos.length;
      },
      totalDescuento() {
        return this.seleccionados.reduce((a, c) => a + (this.porcentualMulti ? this.equivalenteBs(c) : (parseFloat(this.seleccion[c.id]) || 0)), 0);
      },
    },
    watch: {
      concepto: function() {
        this.verificardescuentoporcentual();
      },
      monto: function() {
        this.verificardescuentoporcentual();
      },
      porcentual: function() {
        this.verificardescuentoporcentual();
      },
    },
    components: {},
    methods: {
      validarCampo() {
        let nameRules = [(v) => !this.porcentual || v <= 100 || 'Error'];
        return nameRules;
      },
      verificardescuentoporcentual() {
        if (!this.concepto || !this.monto) return;
        if (this.porcentual) {
          if (this.monto > 100) this.monto = 100;
          this.monto_porcentual = Math.round(this.concepto.monto * (this.monto / 100));
        }
      },
      formatBs(v) {
        const n = parseFloat(v) || 0;
        return n.toLocaleString('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      isSelected(c) { return this.seleccion[c.id] !== undefined; },
      getMonto(c)   { return this.seleccion[c.id]; },
      setMonto(c, v) {
        let val = parseFloat(v) || 0;
        if (this.porcentualMulti && val > 100) val = 100;
        this.$set(this.seleccion, c.id, val);
      },
      toggleConcepto(c) {
        if (this.isSelected(c)) this.$delete(this.seleccion, c.id);
        else this.$set(this.seleccion, c.id, 0);
      },
      seleccionarTodos() {
        if (this.todosSeleccionados) {
          this.seleccion = {};
        } else {
          const nueva = {};
          this.conceptos.forEach(c => { nueva[c.id] = this.seleccion[c.id] || 0; });
          this.seleccion = nueva;
        }
      },
      equivalenteBs(c) {
        if (!this.porcentualMulti) return parseFloat(this.seleccion[c.id]) || 0;
        const pct = parseFloat(this.seleccion[c.id]) || 0;
        return Math.round((c.monto || 0) * (pct / 100));
      },
      getdescuentostipo(ins, programita) {
        this.xprograma = programita;
        this.msg = '';
        this.tab = 0;
        // Tab 1
        this.motivo = {};
        this.concepto = null;
        this.monto = null;
        this.monto_porcentual = null;
        this.porcentual = false;
        this.exitoso = false;
        this.prorratear = false;
        this.descripcion = '';
        // Tab 2
        this.motivoMulti = {};
        this.porcentualMulti = false;
        this.prorratearMulti = false;
        this.descripcionMulti = '';
        this.seleccion = {};

        this.xins = ins;
        this.inscripcion_id = ins.id;
        this.motivos = [];
        this.loading = true;
        const vue = this;
        let id_inscripcion = ins.id;
        let unidad_negocio_id = this.$store.state.CARGO.sede.unidad_negocio;
        const urlm = `${process.env.VUE_APP_API_REST}/api/v1/motivos?descuento_tipo_id=2&unidad_negocio_id=${unidad_negocio_id}`;
        const urld = `${process.env.VUE_APP_API_REST}/api/v1/descuento-tipos`;
        const urlc =
          `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/concepto_pagos?acepta_descuento=true&inscripcion_id=` +
          id_inscripcion;
        const urlp = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${id_inscripcion}/plan-pago`;
        const promise1 = xaxios.get(urlm);
        const promise2 = xaxios.get(urld);
        const promise3 = xaxios.get(urlc);
        const promise4 = xaxios.get(urlp);

        Promise.all([promise1, promise2, promise3, promise4]).then(function(values) {
          let data0 = values[0];
          let data1 = values[1];
          let data2 = values[2];
          if (data0.data == '') data0 = { data: { data: [] } };
          if (data1.data == '') data1 = { data: { data: [] } };

          data1.data.data.forEach((x) => { vue.descuentostipos.push(x); });
          data0.data.data.forEach((x) => {
            let tipodes = vue.descuentostipos.find((t) => t.id == x.descuento_tipo);
            x.xtipodes = tipodes;
            vue.motivos.push(x);
          });
          vue.parseconceptos(data2.data.data);
          vue.loading = false;
        });
      },
      parseconceptos(datos) {
        if (!datos) datos = [];
        let xdatos = [];
        datos.forEach((x) => {
          let d = xdatos.find((a) => a.id == x.id);
          if (!d && x.id != 3) xdatos.push(x);
        });
        this.conceptos = xdatos;
        if (this.conceptos.length == 0) this.msg = 'No hay conceptos que acepten descuentos';
      },
      validar() {
        if (this.tab === 0) {
          this.validarUnico();
        } else {
          this.validarMultiple();
        }
      },
      validarUnico() {
        this.msg = '';
        if (!this.inscripcion_id) { this.msg = 'Inscripcion no encontrada'; return; }
        if (!this.motivo.id)      { this.msg = 'Seleccione un motivo.'; return; }
        if (!this.monto)          { this.msg = 'Ingrese el monto de descuento.'; return; }
        if (!this.concepto)       { this.msg = 'Seleccione un concepto de descuento.'; return; }
        if (!this.descripcion)    { this.msg = 'Escriba una descripcion para soliciatr el descuento'; return; }
        if (this.porcentual && this.monto > 100) { this.msg = 'El monto porcentual no debe pasar el 100%'; return; }
        if (this.monto <= 0)      { this.msg = 'El monto de descuento debe ser un numero entero positivo mayor a cero'; return; }

        let xmonto = this.monto;
        if (this.porcentual) {
          xmonto = this.monto_porcentual;
        }
        if (xmonto > this.concepto.saldo) {
          this.msg =
            'El monto de descuento no puede ser superior al saldo pendiente del concepto: ' + this.concepto.nombre;
          return;
        }

        let data = {
          descripcion: this.descripcion,
          inscripcion_id: this.inscripcion_id,
          monto: xmonto,
          motivo_id: this.motivo.id,
          concepto_pago_id: parseInt(this.concepto.id),
          prorrateado_activo: this.prorratear,
        };

        this.enviar(data);
      },
      validarMultiple() {
        this.msg = '';
        if (!this.inscripcion_id) { this.msg = 'Inscripcion no encontrada'; return; }
        if (!this.motivoMulti.id) { this.msg = 'Seleccione un motivo.'; return; }
        if (this.seleccionados.length === 0) { this.msg = 'Seleccione al menos un concepto.'; return; }
        if (!this.descripcionMulti) { this.msg = 'Escriba una descripción de la solicitud.'; return; }

        for (const c of this.seleccionados) {
          const monto = parseFloat(this.seleccion[c.id]) || 0;
          if (monto <= 0) { this.msg = `Ingrese el monto de descuento para: ${c.nombre}`; return; }
          if (this.porcentualMulti && monto > 100) { this.msg = `El porcentaje para ${c.nombre} no debe pasar el 100%`; return; }
          const montoBs = this.porcentualMulti ? this.equivalenteBs(c) : monto;
          if (montoBs > c.saldo) { this.msg = `El descuento supera el saldo pendiente del concepto: ${c.nombre}`; return; }
        }

        const payload = {
          descripcion: this.descripcionMulti,
          motivo_id: this.motivoMulti.id,
          inscripcion_id: this.inscripcion_id,
          conceptos: this.seleccionados.map(c => ({
            concepto_pago_id: parseInt(c.id),
            monto: this.porcentualMulti ? this.equivalenteBs(c) : (parseFloat(this.seleccion[c.id]) || 0),
            prorrateado: this.prorratearMulti,
          })),
          prorrateado_activo: this.prorratearMulti,
        };

        this.enviarMultiples(payload);
      },
      enviar(data) {
        const vue = this;
        vue.loading = true;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/pagos/descuentos/solicitud`;
        xaxios
          .post(url, data)
          .then((res) => {
            vue.msg = res.data.data;
            vue.loading = false;
            vue.exitoso = true;
          })
          .catch((error) => {
            vue.msg = 'Puede que ya tenga un descuento pendiente de aprobacion o el monto sobrepasa la cuota';
            if (error.response) vue.msg = error.response.data.data;
            vue.loading = false;
          });
      },
      async enviarMultiples(payload) {
        this.loading = true;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/pagos/descuentos/solicitud/multiple`;
        try {
          const res = await xaxios.post(url, payload);
          this.exitoso = true;
          this.msg = res.data?.data || `Se registraron ${payload.conceptos.length} solicitud(es) de descuento correctamente.`;
        } catch (error) {
          this.msg = error.response?.data?.data || 'Error al enviar la solicitud de descuento múltiple';
        } finally {
          this.loading = false;
        }
      },
    },
    mounted() {
      var vue = this;
      window.$('#modal-ndescuento').on('hide', function() {
        vue.msg = '';
        vue.motivo = {};
        vue.monto = null;
        vue.inscripcion_id = null;
        vue.descripcion = '';
        vue.motivoMulti = {};
        vue.descripcionMulti = '';
        vue.seleccion = {};
      });
    },
  };
</script>

<style scoped>
.conceptos-table { border:1px solid #E0E0E0; border-radius:4px; }
.conceptos-table .row-selected { background:#F1F8E9; }
.descuento-input :deep(input) { text-align:right; }
.descuento-input :deep(.v-input__slot) { min-height:32px !important; }
.conceptos-table :deep(td) { padding: 4px 8px !important; }
.conceptos-table :deep(th) { padding: 6px 8px !important; }
.w-100 { width:100% !important; }
</style>
